module.exports = __webpack_public_path__ + "img/testimonial-kristin.8fb69012.png";